export type Auth0SessionLogoutOptions = {
    callback?: () => void;
    skipRedirect?: boolean;
    redirectUrl?: string;
};

export type Auth0SessionLogoutHandler = (options?: Auth0SessionLogoutOptions) => Promise<void>;

let registeredLogoutHandler: Auth0SessionLogoutHandler | null = null;

/**
 * Registers the browser-only Auth0 session-termination handler supplied by the React layer.
 * Must be called from a component mounted under `Auth0Provider`.
 */
export function registerAuth0LogoutHandler(handler: Auth0SessionLogoutHandler): void {
    registeredLogoutHandler = handler;
}

/** Clears the registered logout handler when Auth0 React context unmounts. */
export function unregisterAuth0LogoutHandler(): void {
    registeredLogoutHandler = null;
}

/**
 * Terminates an Auth0-owned session when the shared session layer detects expiry
 * (e.g. inactivity timeout). Returns true when a handler ran.
 */
export async function invokeAuth0LogoutHandler(options?: Auth0SessionLogoutOptions): Promise<boolean> {
    if (!registeredLogoutHandler) {
        return false;
    }

    await registeredLogoutHandler(options);
    return true;
}
